const fullbackGlobal = {};

export class CacheManager {
  static get global() {
    if (typeof globalThis !== 'undefined') {
      return globalThis;
    }
    if (typeof self !== 'undefined') {
      return self;
    }
    if (typeof window !== 'undefined') {
      return window;
    }
    if (typeof global !== 'undefined') {
      return global;
    }
    return fullbackGlobal;
  }

  static get globalCache() {
    if (typeof CacheManager.global._atIconScriptCaches !== 'undefined') {
      return CacheManager.global._atIconScriptCaches;
    }

    CacheManager.global._atIconScriptCaches = new Set();
    return CacheManager.global._atIconScriptCaches;
  }

  static has = val => {
    return CacheManager.globalCache.has(val);
  };

  static add = val => {
    return CacheManager.globalCache.add(val);
  };
}
